import { useCms } from '~/components/hooks/useCms';
import useDataFetcher from '~/components/useDataFetcher';
import type { EmailConfigurationTitleAndSignatureResponse } from '~/server_shared/openapi/data-contracts';

interface UseEmailSignatureHtmlProps {
  claimId?: string;
  referredCommunicationId?: string;
  sendAsUserId?: string;
  isGeneralEmailResponse?: boolean;
  shouldFetch?: boolean;
}

interface UseEmailSignatureHtmlReturn {
  isLoading: boolean;
  isError: boolean;
  data: EmailConfigurationTitleAndSignatureResponse | undefined;
}

function useEmailSignatureHtml({
  claimId,
  referredCommunicationId,
  sendAsUserId,
  isGeneralEmailResponse,
  shouldFetch,
}: UseEmailSignatureHtmlProps): UseEmailSignatureHtmlReturn {
  const { userOrganization } = useCms();

  const url = `/api/v1/email_configuration/organizations/${userOrganization.id}/email_signature_and_title`;

  const params: Record<string, string | undefined> = {};
  if (claimId) {
    params.claim_id = claimId;
  }
  if (referredCommunicationId) {
    params.referred_communication_id = referredCommunicationId;
  }
  if (sendAsUserId) {
    params.send_as_user_id = sendAsUserId;
  }
  if (isGeneralEmailResponse !== undefined) {
    params.is_general_email_response = isGeneralEmailResponse ? 'true' : undefined;
  }

  const { isLoading, isError, data } = useDataFetcher<EmailConfigurationTitleAndSignatureResponse>(
    url,
    { params },
    shouldFetch
  );

  return { isLoading, isError, data };
}

export default useEmailSignatureHtml;
